module.exports = __webpack_public_path__ + "img/pioneer-mockup.17a554ee.jpg";